<template>
  <div class="ml-3 mb-3">
    <div v-for="(label, key) in labels" :key="key" style="display: inline-block; width: 250px;" class="">
      <div :style="'display: inline-block; width: 30px; height: 10px; background-color:' + label.bgColor">
        <i :class="label.icon"></i>
      </div>
      <div class="ml-2" style="display: inline-block; font-size: 9pt">
        {{label.label}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {
    if (this.isUserRoot || this.isUserPlatformEmployee) {
      this.labels.unshift(
          {
            label: 'Pending / Should Create Rates',
            bgColor: '#5f4dee',
            icon: ''
          }
      )
    }
  },
  data () {
    return {
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserPlatformEmployee: $store.getters['user-state/isUserPlatformEmployee'],
      labels: [
        {
          label: 'Working / Test Time',
          bgColor: '#11ca8a',
          icon: ''
        },
        {
          label: 'Awaiting Action / Test Time',
          bgColor: '#11a8ca',
          icon: ''
        },
        {
          label: 'Require Test / Created Time',
          bgColor: '#a79f9f',
          icon: ''
        },
        {
          label: 'FAS / Test Time',
          bgColor: '#FFC300',
          icon: ''
        },/*
        {
          label: 'Unconnected',
          bgColor: '#ca2d11',
          icon: ''
        },*/
        {
          label: 'View Test',
          bgColor: 'transparent',
          icon: 'el-icon-view'
        },
      ]
    }
  }
}
</script>
